import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import ICategory from 'models/ICategory'

export interface CategoriesProps {
  activeCategory: number
  handleCategoryClick: (id: number) => void
}

export const useCategories = (props: CategoriesProps) => {
  const categories: ICategory[] | null = useSelector(
    (state: RootState) => state.categories.categories
  )

  return {
    ...props,
    categories,
  }
}
